import React from 'react';
import classNames from 'classnames';
import {
  Box, makeStyles, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import ListItemContainerWrapper from './ListItemContainer';
import sortActionItemsByCompletedThenPriority from '../../helpers';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  actionItemPaper: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 0),
    borderRadius: theme.radius.md,
  },
  transparent: {
    backgroundColor: 'transparent',
  },
  noTodoPaper: {
    width: '100%',
    display: 'flex',
    padding: theme.spacing(2),
    borderRadius: theme.radius.md,
  },
  fileChips: {},
  fileChip: {
    maxWidth: theme.dimensions.xs,
    backgroundColor: theme.palette.facet.accentGreen,
    color: theme.palette.common.white,
    '&:focus': {
      backgroundColor: theme.palette.facet.accentGreen,
      color: theme.palette.common.white,
    },
    marginRight: theme.spacing(1),
  },
  alignStart: {
    alignSelf: 'flex-start',
    alignItems: 'center',
  },
  alternativeForm: {
    flexBasis: '100%',
  },
}));

export default function Content(props) {
  const {
    actionItemCollection,
    replaceActionItem,
    refreshActionItems,
    background,
  } = props;
  const classes = useStyles();
  const countActionItems = actionItemCollection.resources().length();

  const actionItemListItems = sortActionItemsByCompletedThenPriority(
    actionItemCollection
      .resources()
      .list(),
  ).map(r => (
    <Paper
      className={classNames(classes.actionItemPaper, { [classes.transparent]: background === 'transparent' })}
      key={r.id()}
    >
      <ListItemContainerWrapper resource={r} refreshActionItems={refreshActionItems} replaceActionItem={replaceActionItem} />
    </Paper>
  ));

  return (
    <Box className={classes.root}>
      {countActionItems > 0 ? actionItemListItems : null}
      {countActionItems === 0 ? (
        <Paper className={classes.noTodoPaper} variant="tight">
          <Typography variant="body1" align="center">
            {'Use this space to keep a list of your upcoming actions'}
          </Typography>
        </Paper>
      ) : null}
    </Box>
  );
}

Content.defaultProps = {
  background: 'transparent',
};

Content.propTypes = {
  actionItemCollection: PropTypes.object.isRequired,
  replaceActionItem: PropTypes.func.isRequired,
  refreshActionItems: PropTypes.func.isRequired,
  background: PropTypes.oneOf(['white', 'transparent']),
};
